import { useState } from "react";
import useCreate from "../useCreate";
import toast from "react-hot-toast";

const useToggleReviewVisibility = (productId) => {
  const [toggleId, setToggleId] = useState(null);

  const { setDataToServer } = useCreate({
    url: "product/review/delete",
    refreshUrl: "product/review/list",
    onSuccess: (data) => {
      toast.success("Review status updated successfully", {
        position: "top-right",
        duration: 3000,
      });
      setToggleId(null);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Something went wrong", {
        position: "top-right",
        duration: 3000,
      });
      setToggleId(null);
    },
  });

  const handleToggleVisibility = (ratingId, status) => {
    setToggleId(ratingId);
    setDataToServer.mutate({
      rating_id: ratingId,
      status: status,
    });
  };

  return {
    toggleId,
    handleToggleVisibility,
    isLoading: setDataToServer.isLoading,
  };
};

export default useToggleReviewVisibility;
